import React from 'react';
import PropTypes from 'prop-types';
import { SortableElement } from 'react-sortable-hoc';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IngredientPpiSection from './IngredientPpiSection';
import IngredientQuantity from '../../../common/IngredientQuantity';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import Tooltip from '@material-ui/core/Tooltip';
import { Box, TextField } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  ingredientRoot: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    transition: 'border 300ms ease-out'
  },
  ingredientCompleted: {
    borderLeft: `3px solid ${theme.palette.success.main}`
  },
  ingredientIncomplete: {
    borderLeft: `3px solid ${theme.palette.error.main}`
  },
  ingredientName: {
    fontWeight: 500
  },
  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));
const formatFormulaCode = formulaCode => {
  return `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}`;
};

const IngredientCard = ({
  index,
  ingredientName,
  isExcluded,
  itemCode,
  quantity,
  quantityUom,
  owningOrganization,
  selectedPpiDataId,
  completed = false,
  onChangeSelectedPpi,
  legacyFormulaCode,
  globalIngredientId,
  uomQty,
  uomCode,
  displayQuantityOut,
  displayBomUomLabel,
  handleChangeQtyOut,
  ingredientId,
  handleChangeBomInfoTextShort,
  franchiseType
}) => {
  const classes = useStyles();
  const rootClasses = cx(
    classes.ingredientRoot,
    { [classes.ingredientCompleted]: completed },
    { [classes.ingredientIncomplete]: !completed }
  );
  return (
    <div className={rootClasses}>
      <Grid container spacing={0} style={{ position: 'relative' }}>
        <Grid item md={franchiseType==="NIR"?4:6} sm={6} xs={12}>
          <Typography
            variant="body1"
            className={cx(classes.ingredientName, classes.truncate)}
            noWrap
          >
            {ingredientName}
          </Typography>
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Typography variant="body1">{`${formatFormulaCode(itemCode)}(${
            legacyFormulaCode ? formatFormulaCode(legacyFormulaCode) : '-'
          })`}</Typography>
        </Grid>
        <Grid item md={2} sm={3} xs={12}>
          <Typography variant="body1">
            <IngredientQuantity quantity={quantity} uom={quantityUom} />
          </Typography>
        </Grid>
        
        
        <Grid item xs={12} md={franchiseType==="NIR"?6:9} style={{ position: 'relative' }}>
          <IngredientPpiSection
            ingredientOwningOrganization={owningOrganization}
            onChangeSelectedPpi={onChangeSelectedPpi}
            selectedPpiDataId={selectedPpiDataId}
            itemCode={itemCode}
            isExcluded={isExcluded}
            globalIngredientId={globalIngredientId}
            legacyFormulaCode={legacyFormulaCode}
          />
        </Grid>
        {franchiseType==="NIR"&&<Grid item md={5} sm={12} xs={12} style={{marginTop:'-42px'}}>
          {/* <Typography variant="body1">{owningOrganization}</Typography> */}
          <Box sx={{ p: 2 }}>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Typography variant="subtitle1" gutterBottom>
                          BOM Amount
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle1" gutterBottom>
                          Displayed Amount
                        </Typography>
                      </Grid>

                      <Grid item xs={4}>
                        <TextField size="small" fullWidth variant="outlined" value={uomQty} disabled/>
                      </Grid>
                      <Grid item xs={2}>
                        <TextField size="small" fullWidth variant="outlined" value={uomCode} disabled/>
                      </Grid>

                      <Grid item xs={4}>
                        <TextField size="small" fullWidth variant="outlined" value={displayQuantityOut} 
                        onChange={(e)=>handleChangeQtyOut(e, "displayQuantityOut", ingredientId)} />
                      </Grid>
                      <Grid item xs={2}>
                        <TextField size="small" fullWidth variant="outlined" 
                        onChange={(e)=>handleChangeBomInfoTextShort(e, ingredientId)}
                        value={displayBomUomLabel}/>
                      </Grid>
                    </Grid>
                  </Box>
        </Grid>}
        <Tooltip title="Drag ingredient to change order">
          <DragIndicatorIcon
            style={{
              color: 'rgba(0, 0, 0, 0.54)',
              position: 'absolute',
              top: '50%',
              marginLeft:'98%',
              // marginRight: '8px',
              cursor: 'grab'
            }}
          />
        </Tooltip>
      </Grid>
    </div>
  );
};

IngredientCard.propTypes = {
  completed: PropTypes.bool,
  ingredientName: PropTypes.string.isRequired,
  itemCode: PropTypes.string.isRequired,
  globalIngredientId: PropTypes.string.isRequired,
  onChangeSelectedPpi: PropTypes.func.isRequired,
  owningOrganization: PropTypes.string,
  quantity: PropTypes.number,
  quantityUom: PropTypes.string,
  selectedPpiDataId: PropTypes.string,
  legacyFormulaCode: PropTypes.string
};

export default SortableElement(IngredientCard);
